import {Component} from "../../../gvf/js/component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";
import {ObjectService} from "../../js/object-service";

export class CpLabelGroupComponent extends Component{
    linkLabel(labelId,addLink){
        GvfService.endpoint(
            "/cp/object-detail/"+(addLink?"link-to-label":"unlink-from-label"),
            {modelName:this.model,objectId:this.objectId,labelId:labelId}
        ).then(
            (response)=>{
                const $new = $(response.html);
                this.$root.replaceWith($new);
                GvfUiService.init($new);
            }
        );
    }

    ready(){
        this.model = this.$root.data("model-name");
        this.objectId = this.$root.data("object-id");

        this.findMember("add").click(
            (ev)=>{
                ev.preventDefault();
                ev.stopPropagation();
                const service = new ObjectService("CpLabel");
                service.selectModelItem({}).then((id)=>{
                        this.linkLabel(id,true);
                    }
                );
            }
        );

        this.findMember("open").click(
            (ev)=>{
                ev.preventDefault();
                ev.stopPropagation();
                const service = new ObjectService("CpLabel");
                const $link = $(ev.currentTarget);
                service.openDetailModal(
                    {
                        objectId:$link.attr("href").substring(1),
                        data:{openFromModel:this.model,openFromModelId:this.objectId},
                        readyCallback:($detailPage)=>{
                            $detailPage.on("cpLabelDetail:removeFromLabel",(ev,data)=>{
                                    this.linkLabel(data.label_id,false);
                                }
                            );
                        }
                    }
                );
            }
        );
    }
}
